<template>
    <span>

        <button @click="openModal" :class="buttonClass">
            <slot></slot>
        </button>


        <!-- explanation modal -->
        <div class="modal fade" :id="'report-'+question.id" v-if="showModal"
             tabindex="-1" role="explanation" aria-hidden="true" style="display: none;">
            <div class="modal-dialog">
                <div class="modal-content">
                    <div class="modal-header">
                        <a href="javascript:;" data-dismiss="modal" aria-hidden="true" style="float: right; color: rgb(176, 184, 192);">
                            <i class="fa  fa-times" aria-hidden="true"></i>
                        </a>
                        <h4 class="modal-title">
                            Αναφορά Ερώτησης
                        </h4>
                    </div>
                    <div class="modal-body">

                        <div class="alert alert-info" v-if="success">
                            Η αναφορά σου στάλθηκε με επιτυχία.
                        </div>

                        <div class="note note-warning">
                            <p>Αν νομίζεις ότι υπάρχει κάποιο λάθος στην ερώτηση ή στην επεξήγηση,
                                στείλε μας μια αναφορά και θα το κοιτάξουμε αμέσως.</p>
                        </div>



                        <div class="mt-checkbox-list">
                            <metronic-checkbox name="bad_image"
                                               v-model="badImage">
                                Πρόβλημα στην <strong>εικόνα</strong>
                            </metronic-checkbox>

                            <metronic-checkbox name="bad_sound"
                                               v-model="badSound">
                                Πρόβλημα στον <strong>ήχο</strong>
                            </metronic-checkbox>

                            <metronic-checkbox name="bad_text"
                                               v-model="badText">
                                Πρόβλημα στο <strong>κείμενο</strong>
                            </metronic-checkbox>
                        </div>

                        <textarea name="message" rows="4" class="form-control"
                                  v-model="message" maxlength="1000" placeholder="Μήνυμα">
                        </textarea>


                    </div>
                    <div class="modal-footer">
                        <a class="btn btn-circle default" data-dismiss="modal">Κλείσιμο</a>
                        <a class="btn btn-circle blue" @click="postReport"
                           :disabled="!(badImage || badSound || badText || message) || sent">Αποστολή</a>
                    </div>
                </div>
            </div>
        </div>


    </span>
</template>

<script>
    import MetronicCheckbox from '../MetronicCheckbox.vue';

    function defaultData() {
        return {
            showModal:  false,
            checkBoxes: [],
            message:    '',
            badImage:   false,
            badSound:   false,
            badText:    false,
            sent:       false,
            success:    false
        };
    }

    export default {
        data:       defaultData,
        props:      ['question', 'buttonClass'],
        components: {MetronicCheckbox},
        methods:    {
            openModal() {
                this.showModal = true;
                this.$nextTick(function () {
                    $("#report-" + this.question.id).modal();
                });
            },
            postReport() {
                this.sent = true;
                axios.post('/erotiseis/' + this.question.id + '/report', {
                    report: {
                        bad_image: this.badImage,
                        bad_sound: this.badSound,
                        bad_text:  this.badText,
                        comment:   this.message
                    }
                }).then(() => this.success = true);
            }
        },
        watch:      {
            question() {
                Object.assign(this.$data, defaultData());
            }
        }
    };
</script>